import { defineMessages } from 'react-intl';

export default defineMessages({
  headline: {
    id: 'LOGIN_LOGOUT_HEADLINE',
    defaultMessage: 'Sie sind jetzt ausgeloggt!',
  },
  metaTitle: {
    id: 'LOGIN_LOGOUT_META_TITLE',
    defaultMessage: 'Sie sind erfolgreich ausgeloggt',
  },
  dayHeadline: {
    id: 'LOGIN_LOGOUT_HEADLINE_DAY',
    defaultMessage: 'Schönen Tag!',
  },
  nightHeadline: {
    id: 'LOGIN_LOGOUT_HEADLINE_NIGHT',
    defaultMessage: 'Schönen Abend!',
  },
  morningHeadline: {
    id: 'LOGIN_LOGOUT_HEADLINE_MORNING',
    defaultMessage: 'Schönen Start in den Tag!',
  },
  comeback: {
    id: 'LOGIN_LOGOUT_COMEBACK',
    defaultMessage: 'Wenn Sie XING weiter nutzen wollen, {loginLink}.',
  },
  loginLinkText: {
    id: 'LOGIN_LOGOUT_LOGIN_LINK_TEXT',
    defaultMessage: 'loggen Sie sich bitte erneut ein',
  },
});
